export const requiredFields = [
  'uniqueCode',
  'firstName',
  'lastName',
  'primaryEmail',
  'phoneMobile',
  'postCode',
  'customerCreationDate'
]

export const messages = [
  'Unique code',
  'First name',
  'Last name',
  'Primary email',
  'Phone mobile',
  'Postcode',
  'Customer creation date'
]
